import { Box, Typography } from '@mui/material';
import { DisplayInfo } from 'api/ordering-service/ordering-service.types';
import { useTranslation } from 'react-i18next';
import GroupsDisplayContentTabs from './groups-display-content-tabs/groups-display-content-tabs.component';

type GroupsDisplayContentProps = {
  displayInfos: DisplayInfo[];
};

const GroupsDisplayContent = ({ displayInfos }: GroupsDisplayContentProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="GroupsDisplayContent" mt={2}>
      <Typography variant="h2">
        {t('drawer.groupsDetailsDrawer.displayContent.heading')}
      </Typography>
      <GroupsDisplayContentTabs displayInfos={displayInfos} />
    </Box>
  );
};

export default GroupsDisplayContent;
